/**
 * ODDFISH — Our Agency white intro animations (AOS + strike reveals)
 */
(function () {
  "use strict";

  function initAos() {
    if (typeof AOS === "undefined" || window.__oddfishAosInit) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    AOS.init({ once: true, duration: 800, easing: "ease-out-cubic", offset: 120 });
    window.__oddfishAosInit = true;
  }

  function initIntro() {
    var page = document.querySelector(".oddfish-agency-intro-page");
    if (!page) return;

    initAos();

    var ticking = false;
    window.addEventListener("scroll", function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          handleScroll(page);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    handleScroll(page);
  }

  function handleScroll(page) {
    var windowBottom = window.scrollY + window.innerHeight;

    page.querySelectorAll(".animate").forEach(function (section) {
      var sectionBottom = section.offsetTop + section.offsetHeight - 50;

      if (windowBottom > sectionBottom) {
        section.classList.add("scrolled");
        section.querySelectorAll(".strike").forEach(function (el) {
          el.classList.add("strike-visible");
        });
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initIntro);
  } else {
    initIntro();
  }
})();
